import styled from "styled-components";

export const Button = styled.button`
  background: transparent;
  min-height: 48px;
  font-family: "Space Mono", monospace;
  margin: 8px 0;
  color: #ddd;
  width: 100%;
`;
